import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { useSnackbar } from "../../context/snackbarContext"
import { EAdditionalApplyTargetType } from "../../Enum/EAdditionalApplyTargetType"
import { PostRequest } from "../../services/ApiClientService"

export interface ApplyAdditionalRequest {
  targetType: EAdditionalApplyTargetType
  productIds: number[]
  catalogItemIds: number[]
  comboIds: number[]
}

export const useApplyAdditional = () => {
  const { t } = useTranslation(["general", "addtional"])

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { showSnackbar } = useSnackbar()

  const handleApplyAdditional = async (
    additionalId: number,
    request: ApplyAdditionalRequest,
    onSuccess?: () => void,
  ) => {
    try {
      enableLoad()

      const response = await PostRequest(`${API_ROUTES.ADDTIONAL.APPLY}/${additionalId}`, request)

      if (response.success) {
        onSuccess?.()
        showSnackbar({
          title: t("addtional:snackbar_association_updated_title"),
          description: t("addtional:snackbar_association_updated_description"),
          variant: "success",
        })
        return true
      }

      throw new Error(response.message)
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)

      return false
    } finally {
      disableLoad()
    }
  }

  const handleRemoveAdditionalApply = async (
    additionalId: number,
    request: ApplyAdditionalRequest,
    onSuccess?: () => void,
  ) => {
    try {
      enableLoad()

      const response = await PostRequest(`${API_ROUTES.ADDTIONAL.APPLY_REMOVE}/${additionalId}/remove`, request)

      if (response.success) {
        onSuccess?.()
        showSnackbar({
          title: t("addtional:snackbar_association_removed_title"),
          description: t("addtional:snackbar_association_removed_description"),
          variant: "success",
        })
        return true
      }

      throw new Error(response.message)
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)

      return false
    } finally {
      disableLoad()
    }
  }

  return { handleApplyAdditional, handleRemoveAdditionalApply }
}
